module.exports = __webpack_public_path__ + "img/area_8.3a489fe8.png";